<template>
  <v-app id="snackbar">
    <v-snackbar
      v-for="(snackbar, index) in snackbars"
      :key="index"
      v-model="snackbar.open"
      :color="snackbar.color"
      :style="snackbar.style"
      :timeout="snackbar.timeout"
      text
      top
      right
      multi-line
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-icon
          dark
          class="mx-2"
          v-bind="attrs"
          :color="snackbar.color"
          @click="closeSnackbar(snackbar)"
          >fa-times
        </v-icon>
      </template>
    </v-snackbar>
  </v-app>
</template>
 
<script>
export default {
  name: "Snackbar",

  data: () => ({
    defaultTimeout: 3000,
    itemCount: 6,
    position: -1,
    snackbars: [],
  }),

  created() {
    var i = 0;
    while (i < this.itemCount) {
      this.snackbars.push({
        open: false,
        color: "transparent",
        style: "margin-top:" + (80 * i + 4 - 48) + "px",
        timeout: this.defaultTimeout,
        message: "",
        closeEvent: null,
      });
      i++;
    }
  },

  methods: {
    info(mes, timeout, closeEvent) {
      var position = this.nextPos();
      this.snackbars[position].color = "info";
      this.snackbars[position].timeout =
        typeof timeout != "undefined" ? timeout : this.defaultTimeout;
      this.snackbars[position].message = mes;
      this.snackbars[position].open = true;
      this.snackbars[position].closeEvent = closeEvent;
    },
    error(mes, timeout, closeEvent) {
      var position = this.nextPos();
      this.snackbars[position].color = "error";
      this.snackbars[position].timeout =
        typeof timeout != "undefined" ? timeout : this.defaultTimeout;
      this.snackbars[position].message = mes;
      this.snackbars[position].open = true;
      this.snackbars[position].closeEvent = closeEvent;
    },
    warning(mes, timeout, closeEvent) {
      var position = this.nextPos();
      this.snackbars[position].color = "warning";
      this.snackbars[position].timeout =
        typeof timeout != "undefined" ? timeout : this.defaultTimeout;
      this.snackbars[position].message = mes;
      this.snackbars[position].open = true;
      this.snackbars[position].closeEvent = closeEvent;
    },
    success(mes, timeout, closeEvent) {
      var position = this.nextPos();
      this.snackbars[position].color = "success";
      this.snackbars[position].timeout =
        typeof timeout != "undefined" ? timeout : this.defaultTimeout;
      this.snackbars[position].message = mes;
      this.snackbars[position].open = true;
      this.snackbars[position].closeEvent = closeEvent;
    },
    nextPos() {
      var position = -1;
      this.snackbars.forEach((snackbar, index) => {
        if (position == -1 && !snackbar.open) position = index;
      });
      if (position < 0) {
        this.position =
          this.position + 1 >= this.itemCount ? 0 : this.position + 1;
      } else {
        this.position = position;
      }

      return this.position;
    },
    closeSnackbar(snackbar) {
      if (snackbar.closeEvent) {
        snackbar.closeEvent();
      }
      snackbar.open = false;
    },
  },
};
</script>

<style>
#snackbar .v-application--wrap {
  min-height: 0px;
  max-height: 0px;
}
</style>